export default "__VITE_ASSET__CxmZPkig__"